import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechnologyDevelopmentComponent } from './technology-development/technology-development.component';
import { MobileAppDevelopmentComponent } from './mobile-app-development/mobile-app-development.component';
import { CloudservicesComponent } from './cloudservices/cloudservices.component';
import { DatabaseServicesComponent } from './database-services/database-services.component';
import { OperationMaintananceComponent } from './operation-maintanance/operation-maintanance.component';
import { ArtificialIntelligenceComponent } from './artificial-intelligence/artificial-intelligence.component';
import { TestingServicesComponent } from './testing-services/testing-services.component';
import { CloudPlanningServicesComponent } from './cloud-planning-services/cloud-planning-services.component';
import { CloudDesignServicesComponent } from './cloud-design-services/cloud-design-services.component';
import { CloudModernizationAndMigrationComponent } from './cloud-modernization-and-migration/cloud-modernization-and-migration.component';
import { CloudManagedServicesComponent } from './cloud-managed-services/cloud-managed-services.component';
import { TechnologyStaffingComponent } from './technology-staffing/technology-staffing.component';
import { TechnologyTrainingComponent } from './technology-training/technology-training.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ServicesRoutingModule } from './services-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';

import { register } from 'swiper/element/bundle';
import { JourneyCloudComponent } from './journey-cloud/journey-cloud.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { CybersecurityservicesComponent } from './cloudservices/cybersecurityservices/cybersecurityservices.component';


register();


@NgModule({
  declarations: [
    TechnologyDevelopmentComponent,
    MobileAppDevelopmentComponent,
    CloudservicesComponent,
    DatabaseServicesComponent,
    OperationMaintananceComponent,
    ArtificialIntelligenceComponent,
    TestingServicesComponent,
    CloudPlanningServicesComponent,
    CloudDesignServicesComponent,
    CloudModernizationAndMigrationComponent,
    CloudManagedServicesComponent,
    TechnologyStaffingComponent,
    TechnologyTrainingComponent,
    JourneyCloudComponent,
    CybersecurityservicesComponent,

 
    
  ],schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,MatTabsModule, ServicesRoutingModule, BrowserAnimationsModule,
    CarouselModule,BrowserModule,FontAwesomeModule,SharedModule, ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatDialogModule,
  ]
})
export class ServicesModule { }
